import { api } from './client';

export async function getLearners() {
  return api.get('/learners');
}

export async function getLearner(id) {
  return api.get(`/learners/${id}`);
}

export async function createLearner({ name, age, curriculum_slug, buddy_id, status, onboarding_step }) {
  const body = { name, age };
  if (curriculum_slug) body.curriculum_slug = curriculum_slug;
  if (buddy_id) body.buddy_id = buddy_id;
  if (status) body.status = status;
  if (onboarding_step !== undefined) body.onboarding_step = onboarding_step;
  return api.post('/learners', body);
}

export async function updateLearner(id, updates) {
  return api.patch(`/learners/${id}`, updates);
}

export async function deleteLearner(id) {
  return api.delete(`/learners/${id}`);
}

export async function getRecommendedBand(learnerId, curriculumSlug) {
  return api.get(`/learners/${learnerId}/recommended-band?curriculum_slug=${encodeURIComponent(curriculumSlug)}`);
}

export async function switchCurriculum(learnerId, curriculumSlug) {
  return api.post(`/learners/${learnerId}/switch-curriculum`, { curriculum_slug: curriculumSlug });
}

export async function getBuddies() {
  return api.get('/buddies');
}

// Forwards the full options object so all backend fields pass through:
// { band, knownCharacterIds, evalCharacterIds, skip, confirmed, justThese }.
// Prior `{ band, hardCharacterIds, evalCharacterIds }` destructure silently
// dropped skip / confirmed / justThese (ADR-045 / BP-EVAL-MARK-KNOWN-01).
export async function applyPlacement(learnerId, options) {
  return api.post(`/learners/${learnerId}/placement`, options || {});
}
